export class TimeoutConfig {
  public static WEBSOCKET_LOADER = 6e4;
  public static ALERT_BANNER_ERROR = 5e3;
  public static ALERT_BANNER_SUCCESS = 3e3;
}
